module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAATCAYAAABhh3Y4AAAAAXNSR0IArs4c6QAAAKlJREFUSA1j+P//fwMQvwdiWoLzQMMVGIHEBwYGBn4gpjUoZALacIDWtkDNP8AIYgB9ZwCkBKCCtKAuMDIygkJwFFAeArA4cwAa9Z9y43Ca8BAYZw9ASX8DUIk/TmXUkwgEJX0H6pmH1yQFkGUNQPwQrzLKJTcCjQCF4CgYYiEASvoOQDfb09jdoHJxIQuQWADE8kBMa/ARlPTpBkDBaAC0LYDGNoKCcQEAJSSOL4f9CeAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/hamburger.png
// module id = 625
// module chunks = 114276838955818